<template>
    <div v-if="hidePrice == false && getShowShippingCalculation && !isProductUnavailable">
        <div class="form-group form-group-sm">
            <div>
                <c-label style="margin: 0">Calcular frete</c-label>
                <form class="mb-0" style="display: flex;align-items: center; flex-wrap: wrap;" autocomplete="off">


                    <c-form-group style="max-width: 100px;">
                        <input
                            type="text"
                            value=" "
                            v-model="cepdestino"
                            autocomplete="false"
                            v-mask="'#####-###'"
                            class="form-control form-control-sm"
                            placeholder="CEP"
                            style="width: 100%;height: 3.8rem;"
                            :style="'font-family:'+$root.$children[0].theme.font_family"
                            id="busca-cep"
                            name="busca-cep"
                            @keypress.enter="shippingCalculate()"
                        />
                    </c-form-group>
                    <c-button
                        :backgroundColor="$root.$children[0].theme.products.button.background_color"
                        :backgroundColorHover="$root.$children[0].theme.products.button.background_color_hover"
                        :color="$root.$children[0].theme.products.button.color"
                        :colorHover="$root.$children[0].theme.products.button.color_hover"
                        :borderColor="$root.$children[0].theme.products.button.border_color"
                        :borderColorHover="$root.$children[0].theme.products.button.border_color_hover"
                        :borderRadius="$root.$children[0].theme.products.button.border_radius"
                        margin="0px 0rem 0px 5px"
                        textTransform="uppercase"
                        height="3.8rem"
                        minWidth="unset"
                        padding="1rem 2rem"
                        display="flex"
                        textAlign="center"
                        lineHeight="1.5"
                        letterSpacing="unset"
                        transition="all .3s"
                        justifyContent="center"
                        class="mr-2"
                        @click.prevent="shippingCalculate()"
                    >
                        <span :style="'text-transform:'+$root.$children[0].theme.products.button.text_transform+'; font-size:'+$root.$children[0].theme.font_size_button">Ok</span>
                    </c-button>
                    <div style="width: 100%; margin: 1px">
                        <a
                            @click.prevent="$root.showModalApp('modal_cep')"
                            style="color: #202020; text-decoration: none; cursor: pointer"
                        >
                            Não sei meu CEP
                        </a>
                    </div>

                </form>
            </div>
        </div>
        <clip-loader
            :loading="loadingCalculate"
            :color="colorLoading"
            size="30px"
        >
        </clip-loader>
        <c-span v-if="localDestino && (shippings.frenet || shippings.correio)">{{localDestino}}</c-span>
        <c-span
            v-if="deliveryRestriction.blocked && !loadingCalculate"
            class="delivery-restriction"
            style="display: block; color: #c0392b; margin-top: .5rem;"
        >
            {{ deliveryRestriction.message }}
        </c-span>
        <!-- <template v-if="cepdestino && shippings.correio && !loadingCalculate"> -->
        <template v-if="cepdestino && shippingMethods && !loadingCalculate && !deliveryRestriction.blocked">
            <table class="delivery-table">
                <tbody>
                    <tr
                        v-for="(shipping, key) in shippingMethods"
                        :key="key"
                    >
                        <template v-if="shipping.error === '0'">
                            <td>
                                <c-span
                                    class="text-uppercase"
                                    :title="shipping.type"
                                >
                                    {{ cropString(shipping.type)  }}
                                </c-span>
                                <br>
                                <p v-if="shipping.description" style="width: 200px;"
                                >
                                    {{ shipping.description  }}
                                </p>
                            </td>
                            <td style="vertical-align: top;">
                                <c-span>
                                    {{ +shipping.price > 0 || shipping.type != 'RETIRAR NA LOJA' ? currency.money(shipping.price) : null }}
                                </c-span>
                            </td>
                            <td style="vertical-align: top;">
                                <c-span >
                                    {{ prazoEntrega(shipping.prazoEntrega) }}
                                </c-span>
                            </td>

                        </template>

                    </tr>
                </tbody>
            </table>
        </template>

        <template v-if="cepdestino && shippings.frenet && !loadingCalculate && !deliveryRestriction.blocked">
            <table class="delivery-table">
                <tbody>
                    <tr
                        v-for="(shipping, key) in shippings.frenet"
                        :key="key"
                    >
                        <template v-if="!shipping.Error">
                            <td>
                                <c-span
                                    class="text-uppercase"
                                    :title="shipping.ServiceDescription"
                                >
                                    {{ cropString(shipping.ServiceDescription)  }}
                                </c-span>
                            </td>
                            <td>
                                <c-span>
                                    {{ shipping.ShippingPrice > 0 ? currency.money(shipping.ShippingPrice) : null }}
                                </c-span>
                            </td>
                            <td>
                                <c-span>
                                    {{ prazoEntrega(shipping.DeliveryTime) }}
                                </c-span>
                            </td>
                        </template>
                    </tr>
                </tbody>
            </table>
        </template>
        <SearchPostalCode
            @searchedCep="searchedCep"
        />
    </div>
</template>

<script>
import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
import { CButton } from '../Styles/Button/styled'
import {mapActions, mapGetters, mapState} from 'vuex'
import Currency from '../../helpers/parseCurrency'
import ConsultaCep from '../../api/consultaCep'
import SearchPostalCode from '../SearchPostalCode.vue'
import { CFormGroup, CLabel, CSpan } from '../Styles/Components/styled'

export default {
    name: 'CalculaFrete',
    props: {
        product_id: {
            required: true
        },
        // quantity:{
        //     default:1
        // }
    },
    components: {
        ClipLoader,
        SearchPostalCode,
        'c-button': CButton,
        'c-label': CLabel,
        'c-span': CSpan,
        'c-form-group': CFormGroup
    },
    data() {
        return {
            company: this.$root.$children[0].$attrs.company,
            loadingCalculate: false,
            localDestino: null,
            cepdestino: null,
            colorLoading: this.$root?.$children[0]?.theme?.primary_color ?? 'blue',
            shippings: {},
            currency: Currency,
            shippingMethods:[],
            deliveryRestriction: { blocked: false, message: null },
        }
    },
    methods: {
        ...mapActions("shipping", [
            "ActionShippingCalculateByProduct"
        ]),
        async shippingCalculate() {
            try {

                if(!this.cepdestino) {
                    return alert('Informe um cep')
                }
                // this.$emit('setQuantity', true)
                setTimeout( async () => {
                    this.shippings = {}
                    this.shippingMethods = []
                    this.localDestino = null
                    this.deliveryRestriction = { blocked: false, message: null }
                    this.loadingCalculate = true
                    const dados = {payload: { cep: this.cepdestino, quantity: this.quantity}, id: this.product_id,}
                    const cepIsValid = await this.consultaCep(this.cepdestino)
                    if(!cepIsValid) {
                        this.loadingCalculate = false
                        return;
                    }

                    const response = await this.ActionShippingCalculateByProduct(dados)
                    this.shippings = response.data
                    this.deliveryRestriction = response.delivery_restriction
                        ?? { blocked: false, message: null }
                    if(this.deliveryRestriction.blocked) {
                        this.loadingCalculate = false
                        this.$emit('deliveryBlocked', this.deliveryRestriction)
                        return
                    }
                    let arr = [
                        ...this.shippings.correio,
                        ...this.shippings.rodonaves,
                        ...this.shippings.fflip_fretes??[],
                        ...this.shippings.melhor_envio,
                        ...this.shippings.jamef,
                        ...this.shippings.jadlog,
                        ...this.shippings.ac_express,
                        ...this.shippings.aceville,
                        ...this.shippings.braspress,
                        ...this.shippings.bauer,
                        ...this.shippings.expresso_sao_miguel,
                        ...this.shippings.zanotelli,
                        ...this.shippings.tnt,
                        ...this.shippings.todo_brasil,
                        ...this.shippings.transp_aceville,
                        ...this.shippings.azurelog,
                        ...this.shippings.ebtrans,
                        ...this.shippings.rodovitor,
                        ...this.shippings.agex,
                        ...this.shippings.farias_faz,
                        ...this.shippings.sc_logistica,
                        ...this.shippings.alfa,
                        ...this.shippings.ativa,
                        ...this.shippings.total_express,
                    ]
                    arr.map( el => (!this.shippingMethods.filter(v => v.type === el.type).length) && this.shippingMethods.push(el))
                    this.loadingCalculate = false

                }, 100);

            } catch(error) {
                this.loadingCalculate = false
                alert(error?.msg ?? error)
            }
        },
        prazoEntrega(prazo) {
            if(prazo === null) {
                return
            }
            prazo = +prazo + +this.availability
            if(prazo > 1) {
                return prazo+' dias'
            }
            return prazo+' dia'
        },
        async consultaCep(cep_consulta) {
            if(!cep_consulta) {
                return false
            }
            try {
                let {
                    erro=null,
                    localidade=null,
                    uf=null

                } = await ConsultaCep.get(cep_consulta)
                if(erro) {
                    alert('CEP inválido!')
                    return false
                }
                if(uf && localidade) {
                    this.localDestino = localidade+' - '+uf.toUpperCase()
                }
            } catch(error) {
                alert(error)
                return false
            }
            return true
        },
        cropString(str) {
            const permitido = 22
            const length = str.length
            return length > permitido ? str.substring(0, length-(length - permitido))+'...' : str
        },
        searchedCep(cep){
           this.cepdestino = cep
           this.shippingCalculate()
        }
    },
    computed: {
        ...mapGetters('company', ["getShowShippingCalculation"]),
        ...mapState("products", ['quantity']),
        ...mapGetters("products", ["isProductUnavailable"]),
        ...mapState("products", ["availability"]),
        hidePrice() {
            let hide = this.company?.settings?.hide_price_not_logged_user ?? false
            return ( hide === false ) ? false : ( hide === true && this.isLogged === false ? true : false )
        },
        isLogged() {
            return this.$root.$children[0].$attrs.logged
        }
    },
    watch: {
        cepdestino(val) {
            if(!val) {
                this.localDestino = null
                this.shippings = {}
            }
        },
        product_id(val) {
            this.cepdestino = null
            this.localDestino = null
            this.shippings = {}
        },
    }
}
</script>

<style scoped>
.delivery-table {
    width: 100%;
    border-collapse: collapse;
    margin: 8px 0 8px;
    font-size: .9em;
}
.delivery-table > tbody > tr > td > span {
    font-size: 1.2rem;
}
.text-uppercase {
    text-transform: uppercase !important;
}
</style>
